// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"d3246f89","611":"9983a41e","761":"ce448937","947":"bd0ece9f"}[chunkId] + ".chunk.js";
};